<div class="order-details" [class.is-fetching]="fetching">

    <!-- ===== Fejléc ===== -->
    <div class="od-header">
        <div class="od-header__main">
            <a class="od-back" routerLink="/orders">‹ Vissza a rendelésekhez</a>
            <div class="od-title-row">
                <h1 class="stk-page-title">{{ order?.customer || 'Rendelés' }}</h1>
                <span class="stk-pill od-state-pill" [ngClass]="getStatePillClass()">{{ getOrderStateLabel() }}</span>
                <span class="od-custom-pill" *ngIf="isCustomOrder()" title="Egyedi (rendelésre gyártott) terméket tartalmaz">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3 l4 4 L8 20 H4 v-4 Z"></path></svg>
                    Egyedi rendelés
                </span>
                <a class="stk-chat-share" *ngIf="order?.id && canChat" routerLink="/chat" [queryParams]="{ ref: 'order:' + order?.id }" title="Megosztás a csapatchatben — kiválasztod, kinek küldöd">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 5.5 h16 a1.5 1.5 0 0 1 1.5 1.5 v9 a1.5 1.5 0 0 1 -1.5 1.5 H10 l-4.5 3.5 V17.5 H4 A1.5 1.5 0 0 1 2.5 16 V7 A1.5 1.5 0 0 1 4 5.5 Z"></path></svg>
                    Chatbe
                </a>
            </div>
            <div class="stk-page-sub">
                Rendelés #{{ order?.receipt_id }} · {{ getMerchantName() }}<ng-container *ngIf="order?.country_iso"> · {{ order?.country_iso }}</ng-container>
            </div>
        </div>

        <div class="od-header__actions">
            <!-- Számla -->
            <div class="od-doc action-card--invoice">
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#707870" stroke-width="1.8" stroke-linecap="round"><rect x="5" y="3" width="14" height="18" rx="2"></rect><line x1="9" y1="8" x2="15" y2="8"></line><line x1="9" y1="12" x2="15" y2="12"></line><line x1="9" y1="16" x2="13" y2="16"></line></svg>
                <span class="od-doc__name">Számla</span>
                <span
                    class="od-doc__chip"
                    [class.od-doc__chip--on]="hasInvoice() && !isInvoiceCancelled()"
                    [class.od-doc__chip--red]="isInvoiceCancelled()"
                >{{ getInvoiceChipLabel() }}</span>
                <button
                    *ngIf="hasInvoice() && !isInvoiceCancelled()"
                    type="button"
                    class="od-doc__btn"
                    (click)="downloadInvoice()"
                    title="Számla letöltése (PDF)"
                    aria-label="Letöltés"
                >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="4" x2="12" y2="15"></line><polyline points="7,10 12,15 17,10"></polyline><line x1="5" y1="20" x2="19" y2="20"></line></svg>
                </button>
                <button
                    *ngIf="hasInvoice() && !isInvoiceCancelled()"
                    type="button"
                    class="od-doc__btn od-doc__btn--danger"
                    (click)="cancelInvoice()"
                    [disabled]="cancellingInvoice"
                    title="Számla sztornózása"
                    aria-label="Sztornó"
                >
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>
                </button>
                <button
                    *ngIf="!hasInvoice()"
                    type="button"
                    class="od-doc__btn"
                    (click)="requestInvoiceGeneration()"
                    [disabled]="generatingInvoice"
                    title="Számla létrehozása"
                    aria-label="Számla létrehozása"
                >+</button>
            </div>

            <!-- Címke -->
            <div class="od-doc action-card--label">
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#707870" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.6 13.4 L13.4 20.6 a2 2 0 0 1 -2.8 0 L3.4 13.4 a2 2 0 0 1 -0.6 -1.4 V5 a2 2 0 0 1 2 -2 h7 a2 2 0 0 1 1.4 0.6 l7.4 7.4 a2 2 0 0 1 0 2.8 Z"></path><circle cx="8" cy="8" r="1.6"></circle></svg>
                <span class="od-doc__name">Címke</span>
                <span class="od-doc__chip" [class.od-doc__chip--on]="hasLabel()">{{ getLabelChipLabel() }}</span>
                <button
                    *ngIf="order?.shippypro_label_url"
                    type="button"
                    class="od-doc__btn"
                    (click)="openLabelDocument()"
                    [disabled]="generatingLabel"
                    title="Címke letöltése (PDF)"
                    aria-label="Címke letöltése (PDF)"
                >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="4" x2="12" y2="15"></line><polyline points="7,10 12,15 17,10"></polyline><line x1="5" y1="20" x2="19" y2="20"></line></svg>
                </button>
                <button
                    *ngIf="!hasLabel()"
                    type="button"
                    class="od-doc__btn"
                    (click)="requestLabelGeneration(false)"
                    [disabled]="generatingLabel"
                    title="Címke létrehozása"
                    aria-label="Címke létrehozása"
                >+</button>
                <button
                    type="button"
                    class="od-doc__btn"
                    (click)="requestLabelGeneration(true)"
                    [disabled]="generatingLabel"
                    title="Címke újragenerálása"
                    aria-label="Újragenerálás"
                >⟳</button>
                <button
                    type="button"
                    class="od-doc__btn"
                    (click)="requestReplacementLabelGeneration()"
                    [disabled]="generatingLabel"
                    title="Cseretermék küldése — warranty replacement, 0.00 EUR, proforma számla, hogy a vevőt ne terhelje újra a vám"
                    aria-label="Cseretermék küldése"
                >
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="8.5" x2="18" y2="8.5"></line><polyline points="15,5.5 18,8.5 15,11.5"></polyline><line x1="20" y1="15.5" x2="6" y2="15.5"></line><polyline points="9,12.5 6,15.5 9,18.5"></polyline></svg>
                </button>
            </div>

            <!-- Jelölő címke — vészmegoldás, ha a futár nem ad címkét -->
            <button type="button" class="od-marker-btn" (click)="printMarkerLabel()" title="Jelölő címke nyomtatása (BGFox Kft. + rendelésszám + címzett), 10×15 cm">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="6" y="3" width="12" height="7"></rect><rect x="4" y="10" width="16" height="7" rx="1.5"></rect><rect x="7" y="14" width="10" height="7"></rect></svg>
                Jelölő címke
            </button>

            <!-- Foxpost címke — csak magyar címzettnél -->
            <button type="button" class="od-foxpost-btn" *ngIf="isDomestic" (click)="openFoxpostLabel()" title="Foxpost címke (házhoz vagy automatába)">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7.5 L12 3 L21 7.5 V16.5 L12 21 L3 16.5 Z"></path><polyline points="3,7.5 12,12 21,7.5"></polyline><line x1="12" y1="12" x2="12" y2="21"></line></svg>
                Foxpost címke
            </button>

            <!-- UPS címke (közvetlen API) — a Spring GDS a címke-gombon az alapértelmezett -->
            <button type="button" class="od-ups-btn" (click)="openUpsLabel()" title="UPS címke létrehozása (árajánlattal)">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7.5 L12 3 L21 7.5 V16.5 L12 21 L3 16.5 Z"></path><polyline points="3,7.5 12,12 21,7.5"></polyline><line x1="12" y1="12" x2="12" y2="21"></line></svg>
                UPS címke
            </button>

            <!-- Csere csomag -->
            <button type="button" class="od-replacement-btn" (click)="startReplacementDraft()">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="12" y1="4" x2="12" y2="20"></line><line x1="4" y1="12" x2="20" y2="12"></line></svg>
                Csere csomag
            </button>
        </div>
    </div>

    <div class="od-grid">

        <!-- ===== BAL OSZLOP ===== -->
        <div class="od-main">

            <!-- Összegző kártya -->
            <div class="sum-card">
                <div class="sum-cell">
                    <div class="sum-kicker">
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><rect x="3" y="5" width="18" height="16" rx="2"></rect><line x1="3" y1="10" x2="21" y2="10"></line><line x1="8" y1="3" x2="8" y2="7"></line><line x1="16" y1="3" x2="16" y2="7"></line></svg>
                        Szállítási határidő
                    </div>
                    <div class="sum-deadline">
                        <span class="sum-deadline__date">{{ order?.shipping_expected_at ? (order?.shipping_expected_at | date:'MMM dd.') : 'Nincs megadva' }}</span>
                        <span
                            class="sum-deadline__due"
                            *ngIf="getDueLabel()"
                            [class.is-today]="getDueTone() === 'today'"
                            [class.is-late]="getDueTone() === 'late'"
                        >{{ getDueLabel() }}</span>
                    </div>
                    <div class="sum-meta">Beérkezett: {{ order?.created_at | date:'MMM dd, yyyy' }}</div>
                </div>

                <div class="sum-cell">
                    <div class="sum-kicker">
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21 C8 16.5 6 13.5 6 10.5 a6 6 0 0 1 12 0 C18 13.5 16 16.5 12 21 Z"></path><circle cx="12" cy="10.5" r="2.4"></circle></svg>
                        <span class="sum-kicker__label">Címzett</span>
                        <button type="button" class="sum-edit-btn" (click)="toggleAddressEditor()" title="Címzett szerkesztése" aria-label="Címzett szerkesztése">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3 l4 4 L8 20 H4 v-4 Z"></path></svg>
                        </button>
                    </div>

                    <ng-container *ngIf="!showAddressEditor">
                        <div class="sum-addr-name">{{ order?.customer }}</div>
                        <div class="sum-addr-lines">
                            <ng-container *ngFor="let line of getAddrStreetLines()">{{ line }}<br></ng-container>
                            {{ getAddrCityLine() }}
                        </div>
                        <div class="sum-contact" *ngIf="order?.customer_email">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#9AA098" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"></rect><polyline points="3,7 12,13 21,7"></polyline></svg>
                            <a class="sum-contact__text sum-contact__link" [href]="'mailto:' + order?.customer_email">{{ order?.customer_email }}</a>
                        </div>
                        <div class="sum-contact" *ngIf="order?.customer_phone">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#9AA098" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M5 4 h4 l2 5 l-2.5 1.5 a11 11 0 0 0 5 5 L15 13 l5 2 v4 a2 2 0 0 1 -2 2 A16 16 0 0 1 3 6 a2 2 0 0 1 2 -2 Z"></path></svg>
                            <span class="sum-contact__text">{{ order?.customer_phone }}</span>
                        </div>
                    </ng-container>

                    <form class="sum-addr-form" *ngIf="showAddressEditor" [formGroup]="addressForm">
                        <input class="sum-addr-input" type="text" formControlName="customer" placeholder="Név">
                        <input class="sum-addr-input" type="text" formControlName="shipping_address_line1" placeholder="Cím 1">
                        <input class="sum-addr-input" type="text" formControlName="shipping_address_line2" placeholder="Cím 2">
                        <div class="sum-addr-form__row">
                            <input class="sum-addr-input sum-addr-input--zip" type="text" formControlName="shipping_postal_code" placeholder="Irsz." title="Irányítószám">
                            <input class="sum-addr-input sum-addr-input--city" type="text" formControlName="shipping_city" placeholder="Város">
                            <input class="sum-addr-input sum-addr-input--country" type="text" formControlName="shipping_country" placeholder="Ország" title="Ország (ISO)">
                        </div>
                        <input class="sum-addr-input" type="text" formControlName="customer_email" placeholder="E-mail">
                        <input class="sum-addr-input" type="text" formControlName="customer_phone" placeholder="Telefonszám">
                        <div class="sum-addr-form__actions">
                            <button type="button" class="sum-addr-save" [disabled]="savingAddress" (click)="saveAddress()">
                                {{ savingAddress ? 'Mentés…' : 'Mentés' }}
                            </button>
                            <button type="button" class="sum-addr-cancel" [disabled]="savingAddress" (click)="toggleAddressEditor()">Mégse</button>
                        </div>
                    </form>
                </div>

                <div class="sum-cell">
                    <div class="sum-kicker">
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="12" height="9" rx="1.5"></rect><path d="M14 10 h4 l3 3 v3 h-7"></path><circle cx="7" cy="18.5" r="1.7"></circle><circle cx="17" cy="18.5" r="1.7"></circle></svg>
                        Szállítás
                    </div>
                    <div [title]="getShippingRateTooltip()" class="sum-ship-main">{{ getRecommendedShippingLine() }}</div>
                    <div class="sum-meta">{{ getLabelSummary() }}</div>
                    <div class="sum-meta">{{ getPaymentLine() }}</div>
                    <div class="sum-cust-msg" *ngIf="order?.customer_message?.trim()">„{{ order?.customer_message }}”</div>

                    <div class="sum-tracking sum-tracking--pending" *ngIf="generatingLabel && !getTrackingCode()">
                        Tracking lekérése a ShippyPro API-ból…
                    </div>
                    <div class="sum-tracking" *ngIf="getTrackingCode() as tracking">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="10.5" r="2.4"></circle><path d="M12 21 C8 16.5 6 13.5 6 10.5 a6 6 0 0 1 12 0 C18 13.5 16 16.5 12 21 Z"></path></svg>
                        {{ tracking }}
                        <span class="sum-tracking__src">· {{ order?.shippypro_tracking_number === tracking ? 'ShippyPro' : 'kézzel rögzítve' }}</span>
                    </div>
                </div>
            </div>

            <!-- Vevői megjegyzés (Etsy / webshop / manuál rendelés) -->
            <div class="cust-msg-card" *ngIf="order?.customer_message?.trim()">
                <div class="cust-msg-card__kicker">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12 a8 7 0 0 1 -8 7 H8 l-5 3 1 -4.5 A7 7 0 0 1 3 12 a8 7 0 0 1 8 -7 h2 a8 7 0 0 1 8 7 Z"></path></svg>
                    Vevői megjegyzés
                </div>
                <div class="cust-msg-card__text">„{{ order?.customer_message }}"</div>
            </div>

            <!-- Csomagolási lista -->
            <div class="pack-head">
                <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8 L12 3 L3 8 v8 l9 5 l9 -5 Z"></path><polyline points="3,8 12,13 21,8"></polyline><line x1="12" y1="13" x2="12" y2="21"></line></svg>
                <h2 class="pack-head__title">Csomagolási lista</h2>
                <span class="pack-head__count">{{ getPackedRowCount() }} / {{ fulfillmentRows.length }} tétel kész</span>
                <button type="button" class="pack-head__add" (click)="toggleAddItem()" title="Termék hozzáadása a rendeléshez (pótlás — nem kerül a számlára)">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                    Termék hozzáadása
                </button>
            </div>

            <!-- Termék hozzáadása panel -->
            <div class="pack-add" *ngIf="addItemOpen">
                <div class="pack-add__row">
                    <input class="pack-add__input" type="text" placeholder="Termék keresése név vagy SKU alapján…"
                           [value]="addItemSearch" (input)="searchAddItem($any($event.target).value)">
                    <input class="pack-add__qty" type="number" min="1" [(ngModel)]="addItemQty" [ngModelOptions]="{standalone:true}" title="Darabszám">
                    <button type="button" class="pack-add__save" [disabled]="!addItemSelected || savingItem" (click)="confirmAddItem()">Hozzáadás</button>
                    <button type="button" class="pack-add__cancel" (click)="toggleAddItem()">Mégse</button>
                </div>
                <div class="pack-add__results" *ngIf="addItemResults.length">
                    <button type="button" class="pack-add__result" *ngFor="let r of addItemResults" (click)="pickAddItem(r)">
                        <span class="pack-add__result-name">{{ r.name }}</span>
                        <span class="pack-add__result-sku">{{ r.sku }}</span>
                    </button>
                </div>
                <div class="pack-add__note">A hozzáadott tétel pótlásként kerül a csomagolási listára — nem jelenik meg a számlán és a szállítmányban.</div>
            </div>

            <div class="pack-list">
                <div
                    class="pack-item"
                    *ngFor="let row of fulfillmentRows"
                    [class.is-packed]="row.isPackaged"
                    [class.is-removed]="row.removed"
                >
                    <div class="pack-item__row">
                        <div
                            class="pack-item__box"
                            (click)="toggleFulfillmentRow(row)"
                            [class.is-checked]="row.isPackaged"
                            [class.is-disabled]="!row.canTogglePackaging || isRowActionPending(row)"
                            [attr.title]="!row.canTogglePackaging ? 'Ehhez a tételhez nem tartozik csomagolható egység' : (row.isPackaged ? 'Tétel újranyitása' : 'Tétel készre jelölése')"
                        >
                            <svg *ngIf="row.isPackaged && !isRowActionPending(row)" width="14" height="14" viewBox="0 0 14 14"><polyline points="2,7.5 5.5,11 12,3.5" fill="none" stroke="#2E3A1F" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"></polyline></svg>
                            <span class="pack-item__box-busy" *ngIf="isRowActionPending(row)"></span>
                        </div>

                        <div class="pack-item__thumb">
                            <img *ngIf="row.imageFile; else rowThumbFallback" [appFetchComponentImage]="row.imageFile" [alt]="row.name">
                            <ng-template #rowThumbFallback><span class="pack-item__thumb-fallback">fotó</span></ng-template>
                        </div>

                        <div class="pack-item__copy">
                            <div class="pack-item__name">
                                {{ row.name }}
                                <span class="pack-item__custom" *ngIf="isCustomRow(row)" title="Egyedi, rendelésre gyártott termék">Egyedi</span>
                                <span class="pack-item__removed-pill" *ngIf="row.removed" title="Törölve — kimarad a számlából és a szállítmányból">Törölve</span>
                                <span class="pack-item__added-pill" *ngIf="row.isAdded && !row.removed" title="Utólag hozzáadott tétel — nem kerül a számlára és a szállítmányba">Pótlás</span>
                            </div>
                            <div class="pack-item__meta">{{ row.sku }} · {{ row.quantity }} db</div>
                        </div>

                        <button
                            type="button"
                            class="pack-item__remove-btn"
                            *ngIf="row.productId"
                            [disabled]="savingItem"
                            [title]="row.removed ? 'Tétel visszaállítása' : 'Tétel törlése a rendelésből'"
                            (click)="toggleRemoveItem(row)"
                        >
                            <svg *ngIf="!row.removed" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="7" x2="20" y2="7"></line><path d="M9 7 V5 a1 1 0 0 1 1 -1 h4 a1 1 0 0 1 1 1 v2"></path><path d="M6 7 l1 13 a1 1 0 0 0 1 1 h8 a1 1 0 0 0 1 -1 l1 -13"></path></svg>
                            <span *ngIf="row.removed">Visszaállít</span>
                        </button>

                        <!-- Készlet-hiány jelölés + átruházás -->
                        <span class="stk-pill stk-pill--red pack-item__stock-pill" *ngIf="row.stockOut">Nincs készleten</span>
                        <span class="stk-pill stk-pill--yellow pack-item__stock-pill" *ngIf="row.lastPiece && !row.stockOut">Utolsó darab!</span>
                        <button
                            type="button"
                            class="pack-item__realloc"
                            *ngIf="(row.stockOut || row.lastPiece) && row.componentId"
                            title="Készlet átruházása rendelések között"
                            (click)="openRealloc(row)"
                        >
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15,4 19,8 15,12"></polyline><line x1="19" y1="8" x2="6" y2="8"></line><polyline points="9,20 5,16 9,12"></polyline><line x1="5" y1="16" x2="18" y2="16"></line></svg>
                            Átruházás
                        </button>

                        <button
                            type="button"
                            class="pack-item__toggle"
                            *ngIf="row.canExpand"
                            (click)="toggleRowExpansion(row)"
                        >{{ isRowExpanded(row) ? 'Összetevők elrejtése' : 'Összetevők' }}</button>
                    </div>

                    <div class="pack-item__personalization" *ngIf="row.personalization || editingPersonalizationKey === row.key">
                        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#8A6A28" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20 h9"></path><path d="M16.5 3.5 a2.1 2.1 0 0 1 3 3 L7 19 l-4 1 l1 -4 Z"></path></svg>
                        <div class="pack-item__personalization-copy">
                            <div class="pack-item__personalization-kicker">Vevő választásai / személyre szabás</div>
                            <ng-container *ngIf="editingPersonalizationKey !== row.key; else personalizationEditor">
                                <div class="pack-item__personalization-text">{{ row.personalization }}</div>
                            </ng-container>
                            <ng-template #personalizationEditor>
                                <textarea
                                    class="pack-item__personalization-input"
                                    rows="4"
                                    [(ngModel)]="personalizationDraft" [ngModelOptions]="{standalone:true}"
                                    placeholder="pl. Personalization: Salticidae"
                                ></textarea>
                                <div class="pack-item__personalization-actions">
                                    <button type="button" class="pack-item__personalization-save" [disabled]="savingItem" (click)="savePersonalization(row)">Mentés</button>
                                    <button type="button" class="pack-item__personalization-cancel" [disabled]="savingItem" (click)="cancelPersonalization()">Mégse</button>
                                </div>
                            </ng-template>
                        </div>
                        <button
                            type="button"
                            class="pack-item__personalization-edit"
                            *ngIf="row.productId && !row.removed && editingPersonalizationKey !== row.key"
                            title="Személyre szabás átírása"
                            (click)="editPersonalization(row)"
                        >Átírás</button>
                    </div>
                    <button
                        type="button"
                        class="pack-item__personalization-add"
                        *ngIf="!row.personalization && row.productId && !row.removed && editingPersonalizationKey !== row.key"
                        (click)="editPersonalization(row)"
                    >+ Személyre szabás megadása</button>

                    <div class="pack-item__components" *ngIf="isRowExpanded(row)">
                        <div class="pack-comp" *ngFor="let unit of row.unitSummaries">
                            <div class="pack-comp__thumb">
                                <img *ngIf="unit.imageFile" [appFetchComponentImage]="unit.imageFile" [alt]="unit.name">
                            </div>
                            <div class="pack-comp__name">{{ unit.name }}</div>
                            <div class="pack-comp__meta">{{ getUnitMeta(unit) }}</div>
                        </div>
                    </div>
                </div>

                <div class="pack-empty" *ngIf="!fetching && !fulfillmentRows.length">
                    Nincs megjeleníthető csomagolási tétel.
                </div>
            </div>

            <!-- Csere csomag piszkozat -->
            <div class="repl-draft" *ngIf="replacementDraft">
                <div class="repl-draft__head">
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8 L12 3 L3 8 v8 l9 5 l9 -5 Z"></path><polyline points="3,8 12,13 21,8"></polyline><line x1="12" y1="13" x2="12" y2="21"></line></svg>
                    <h3 class="repl-draft__title">Csere csomag összeállítása</h3>
                    <span class="repl-draft__pill">Piszkozat</span>
                </div>
                <div class="repl-draft__desc">Jelöld ki a pótolandó tételeket és az okot (pl. törötten érkezett, kimaradt a csomagból).</div>

                <div class="repl-draft__reasons">
                    <button
                        type="button"
                        class="repl-reason"
                        *ngFor="let reason of replacementReasons"
                        [class.is-active]="replacementDraft.reason === reason"
                        (click)="pickReplacementReason(reason)"
                    >{{ reason }}</button>
                </div>

                <div class="repl-draft__items">
                    <div
                        class="repl-draft-item"
                        *ngFor="let row of fulfillmentRows"
                        [class.is-selected]="isReplacementSelected(row)"
                        (click)="toggleReplacementSelection(row)"
                    >
                        <div class="repl-draft-item__box" [class.is-checked]="isReplacementSelected(row)">
                            <svg *ngIf="isReplacementSelected(row)" width="12" height="12" viewBox="0 0 14 14"><polyline points="2,7.5 5.5,11 12,3.5" fill="none" stroke="#2E3A1F" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"></polyline></svg>
                        </div>
                        <div class="repl-draft-item__name">{{ row.name }}</div>
                        <div class="repl-draft-item__sku">{{ row.sku }}</div>
                    </div>
                </div>

                <div class="repl-draft__actions">
                    <button
                        type="button"
                        class="repl-draft__save"
                        [class.is-enabled]="getReplacementSelectionCount() > 0"
                        [disabled]="getReplacementSelectionCount() === 0"
                        (click)="saveReplacementDraft()"
                    >Csere csomag létrehozása</button>
                    <button type="button" class="repl-draft__cancel" (click)="cancelReplacementDraft()">Elvetés</button>
                </div>
            </div>

            <!-- Létrehozott csere csomagok -->
            <div class="repl-list" *ngIf="replacements.length">
                <div class="repl-card" *ngFor="let rep of replacements; let ri = index">
                    <div class="repl-card__head">
                        <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="#4C8A66" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8 L12 3 L3 8 v8 l9 5 l9 -5 Z"></path><polyline points="3,8 12,13 21,8"></polyline><line x1="12" y1="13" x2="12" y2="21"></line></svg>
                        <div class="repl-card__copy">
                            <div class="repl-card__title">{{ rep.title }}</div>
                            <div class="repl-card__detail">{{ rep.detail }}</div>
                            <div class="repl-card__detail" *ngIf="rep.trackingCode">
                                Küldeménykód: {{ rep.trackingCode }}<ng-container *ngIf="rep.carrierName"> · {{ rep.carrierName }}</ng-container>
                            </div>
                        </div>
                        <span class="stk-pill stk-pill--yellow">Új csomag</span>
                        <div class="repl-card__label">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#707870" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.6 13.4 L13.4 20.6 a2 2 0 0 1 -2.8 0 L3.4 13.4 a2 2 0 0 1 -0.6 -1.4 V5 a2 2 0 0 1 2 -2 h7 a2 2 0 0 1 1.4 0.6 l7.4 7.4 a2 2 0 0 1 0 2.8 Z"></path><circle cx="8" cy="8" r="1.6"></circle></svg>
                            <span class="repl-card__label-name">Címke</span>
                            <span class="od-doc__chip" [class.od-doc__chip--on]="rep.label">{{ rep.label ? 'Létrehozva' : 'Nincs' }}</span>
                            <button
                                *ngIf="hasReplacementLabelDocument(rep)"
                                type="button"
                                class="od-doc__btn od-doc__btn--sm"
                                (click)="openReplacementLabelDocument(rep)"
                                title="Csere csomag címkéje (PDF)"
                                aria-label="Csere csomag címkéje (PDF)"
                            >
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="4" x2="12" y2="15"></line><polyline points="7,10 12,15 17,10"></polyline><line x1="5" y1="20" x2="19" y2="20"></line></svg>
                            </button>
                            <button
                                *ngIf="!rep.label"
                                type="button"
                                class="od-doc__btn od-doc__btn--sm"
                                (click)="requestReplacementLabelGeneration(ri)"
                                [disabled]="generatingLabel"
                                title="Címke létrehozása ehhez a csomaghoz"
                                aria-label="Címke létrehozása ehhez a csomaghoz"
                            >+</button>
                            <button
                                *ngIf="!rep.label"
                                type="button"
                                class="od-doc__btn od-doc__btn--sm od-doc__btn--ups"
                                (click)="openUpsLabel(ri)"
                                title="UPS címke ehhez a csomaghoz"
                                aria-label="UPS címke ehhez a csomaghoz"
                            >UPS</button>
                            <button
                                *ngIf="!rep.label && isDomestic"
                                type="button"
                                class="od-doc__btn od-doc__btn--sm od-doc__btn--foxpost"
                                (click)="openFoxpostLabel(ri)"
                                title="Foxpost címke ehhez a csomaghoz"
                                aria-label="Foxpost címke ehhez a csomaghoz"
                            >FP</button>
                            <button
                                type="button"
                                class="od-doc__btn od-doc__btn--sm od-doc__btn--danger"
                                (click)="removeReplacement(ri)"
                                title="Csere csomag törlése"
                                aria-label="Csere csomag törlése"
                            >
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="7" x2="20" y2="7"></line><path d="M9 7 V5 a1 1 0 0 1 1 -1 h4 a1 1 0 0 1 1 1 v2"></path><path d="M6 7 l1 13 a1 1 0 0 0 1 1 h8 a1 1 0 0 0 1 -1 l1 -13"></path></svg>
                            </button>
                        </div>
                    </div>

                    <div class="repl-card__foot">
                        <div class="repl-card__pkgs">
                            <button
                                type="button"
                                class="repl-pkg-chip"
                                *ngFor="let pkg of pkgTypes"
                                [class.is-active]="rep.pkg === pkg"
                                (click)="pickReplacementPkg(ri, pkg)"
                            >{{ pkg }}</button>
                        </div>
                        <div class="repl-card__dims">Méret: <span>{{ pkgPresets[rep.pkg] }}</span></div>
                        <div class="repl-card__weight">
                            Súly:
                            <input
                                type="text"
                                [ngModel]="rep.weight"
                                (ngModelChange)="setReplacementWeight(ri, $event)"
                                (blur)="flushReplacementSave(ri)"
                                [ngModelOptions]="{ standalone: true }"
                            >
                            g
                        </div>
                        <div class="repl-card__spacer"></div>
                        <div class="repl-card__cost">Szállítási költség: {{ getReplacementCostLine(rep) }}</div>
                    </div>
                </div>
            </div>

            <!-- Csomag adatok -->
            <div class="pkg-card">
                <div class="pkg-card__kicker">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="7" width="18" height="13" rx="2"></rect><polyline points="3,7 12,3 21,7"></polyline><line x1="12" y1="12" x2="12" y2="15"></line></svg>
                    Csomag adatok
                </div>
                <div class="pkg-card__row">
                    <div class="pkg-card__pkgs">
                        <button
                            type="button"
                            class="repl-reason"
                            *ngFor="let pkg of pkgTypes"
                            [class.is-active]="pkgType === pkg"
                            (click)="pickPkgType(pkg)"
                        >{{ pkg }}</button>
                    </div>
                    <div class="pkg-card__dims">Méret: <span>{{ pkgPresets[pkgType] }}</span></div>
                    <div class="pkg-card__weight">
                        Súly:
                        <input
                            type="text"
                            [ngModel]="pkgWeight"
                            (ngModelChange)="setPkgWeight($event)"
                            (blur)="flushPackageSave()"
                            [ngModelOptions]="{ standalone: true }"
                        >
                        g
                    </div>
                    <div class="pkg-card__hint">A méret és súly alapján a rendszer szállítási árat kalkulál.</div>
                </div>
            </div>

            <!-- Lábléc akciósáv -->
            <div class="foot-bar">
                <div class="foot-bar__progress">
                    <div class="foot-bar__track">
                        <div class="foot-bar__fill" [style.width.%]="getPackedPercent()"></div>
                    </div>
                    <div class="foot-bar__label">{{ getProgressLabel() }}</div>
                </div>
                <button
                    type="button"
                    class="foot-bar__undo"
                    *ngIf="order?.packaging_ready === 1"
                    (click)="requestPackagingReady(false)"
                    [disabled]="savingPackaging"
                >Csomagolás visszavonása</button>
                <button
                    type="button"
                    class="foot-bar__complete"
                    [class.is-complete]="isPackagingCompleted()"
                    [class.is-ready]="!isPackagingCompleted() && areAllComponentsPackaged()"
                    [disabled]="isCompleteButtonDisabled()"
                    (click)="requestPackagingReady(true)"
                >{{ isPackagingCompleted() ? 'Teljesítve ✓' : (savingPackaging ? 'Mentés…' : 'Teljesítve') }}</button>
            </div>

        </div>

        <!-- ===== JOBB OSZLOP ===== -->
        <aside class="od-aside">

            <!-- Support: a rendeléshez kötött taskok és levelezések (csak ha van) -->
            <app-order-support-panel [orderId]="orderId"></app-order-support-panel>

            <!-- Módosítások: ki, mikor, mit változtatott (csak ha volt) -->
            <app-order-change-log [orderId]="orderId" [version]="order"></app-order-change-log>

            <!-- Pénzügyek -->
            <div class="fin-card">
                <div class="fin-card__head" (click)="toggleFin()">
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round"><circle cx="12" cy="12" r="8.5"></circle><path d="M14.5 9.3 a3 3 0 1 0 0 5.4"></path></svg>
                    <h3 class="fin-card__title">Pénzügyek</h3>
                    <span class="fin-card__pill" *ngIf="profitValue" [class.is-negative]="profitNegative">{{ profitValue }} · {{ profitPct }}</span>
                    <span class="fin-card__chevron" [class.is-open]="finOpen">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#707870" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6,9 12,15 18,9"></polyline></svg>
                    </span>
                </div>
                <div class="fin-card__body" *ngIf="finOpen">
                    <div class="fin-row" *ngFor="let f of finRows">
                        <span class="fin-row__label">{{ f.label }}</span>
                        <span class="fin-row__val" [class.is-neg]="f.negative">{{ f.value }}</span>
                    </div>
                    <div class="fin-total">
                        <span class="fin-total__label">Profit (nettó)</span>
                        <span class="fin-total__val" [class.is-neg]="profitNegative">{{ profitValue }}</span>
                    </div>
                    <div class="fin-note">{{ finNote }}</div>
                </div>
            </div>

            <!-- Nyomkövetés — a Pénzügyek alatt, az Üzenőfal fölött. -->
            <app-tracking-panel [orderId]="orderId"></app-tracking-panel>

            <!-- Üzenőfal -->
            <div class="msg-card">
                <div class="msg-card__head">
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12 a8 8 0 0 1 -8 8 H4 l2 -3 a8 8 0 1 1 15 -5 Z"></path></svg>
                    <h3 class="msg-card__title">Üzenőfal</h3>
                    <span class="msg-card__count">{{ messages.length }} üzenet</span>
                </div>

                <div class="msg-list">
                    <div class="msg-item" *ngFor="let m of messages">
                        <div class="msg-item__avatar" [appUserAvatar]="m.author">{{ getMessageInitials(m.author) }}</div>
                        <div class="msg-item__body">
                            <div class="msg-item__meta">
                                <span class="msg-item__author">{{ m.author }}</span>
                                <span class="msg-item__time">{{ formatMessageTime(m.createdAt) }}</span>
                            </div>
                            <div class="msg-item__text">{{ m.text }}</div>
                        </div>
                        <button
                            type="button"
                            class="msg-item__del"
                            *ngIf="m.own"
                            (click)="deleteMessage(m)"
                            title="Üzenet törlése"
                            aria-label="Üzenet törlése"
                        >
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="7" x2="20" y2="7"></line><path d="M9 7 V5 a1 1 0 0 1 1 -1 h4 a1 1 0 0 1 1 1 v2"></path><path d="M6 7 l1 13 a1 1 0 0 0 1 1 h8 a1 1 0 0 0 1 -1 l1 -13"></path></svg>
                        </button>
                    </div>
                    <div class="msg-empty" *ngIf="!loadingMessages && !messages.length">Még nincs üzenet ehhez a rendeléshez.</div>
                </div>

                <div class="msg-input-row">
                    <input
                        type="text"
                        class="msg-input"
                        placeholder="Írj üzenetet a kollégáknak…"
                        [ngModel]="msgInput"
                        (ngModelChange)="msgInput = $event"
                        (keydown.enter)="sendMessage()"
                        [ngModelOptions]="{ standalone: true }"
                    >
                    <button
                        type="button"
                        class="msg-send"
                        (click)="sendMessage()"
                        [disabled]="sendingMessage"
                        title="Küldés"
                        aria-label="Küldés"
                    >
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="12" x2="19" y2="12"></line><polyline points="13,6 19,12 13,18"></polyline></svg>
                    </button>
                </div>
            </div>

        </aside>
    </div>
</div>

<!-- Készlet-átruházás modál (közös komponens) -->
<app-stock-realloc
    [product]="reallocProduct"
    (closed)="reallocProduct = null"
    (saved)="onReallocSaved()"
></app-stock-realloc>
